import { Row, Col, Form } from "react-bootstrap";
import { UnitPicker, ColorPicker } from "..";
import { DeviceSelected, WidgetTypeList } from "types";
import { displaySensorType } from "utils/functions";
import CloseOutlined from "@mui/icons-material/CloseOutlined";
import { GATEWAY_LABEL, LDSU_UUID_LABEL } from "constant/displayLabels";

type SelectedDeviceList = {
    devices: Array<DeviceSelected>;
    onChange: (
        divice: DeviceSelected,
        changes: Partial<DeviceSelected>
    ) => void;
    onRemove: (divice: DeviceSelected) => void;
};
export interface SingleSelectedDeviceListProps extends SelectedDeviceList {
    type: WidgetTypeList;
}

const ChartDeviceList = ({
    devices,
    onChange,
    onRemove,
}: SelectedDeviceList) => {
    return (
        <div className="cstm-table w-100 px-2">
            {/* Header Row */}
            <Row className="d-none d-md-flex table-head px-2">
                <Col md={1}>Sensor</Col>
                <Col md={2}>Widget name</Col>
                <Col md={1}>Type</Col>
                <Col md={2}>{GATEWAY_LABEL}</Col>
                <Col md={2}>{LDSU_UUID_LABEL}</Col>
                <Col md={1}>Unit</Col>
                <Col md={1}>Color</Col>
                <Col md={2}>Alert line</Col>
            </Row>
            {/* Data Rows */}
            {devices.map((device, idx) => (
                <Row
                    key={device.ldsuUID + idx}
                    className="bg-secondary px-2 mb-2 align-items-center"
                >
                    <Col xs={12} md={1} className="py-2 text-truncate">
                        <span title={device.sensorName}>
                            {device.sensorName}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2">
                        <Form.Control
                            type="text"
                            defaultValue={device.chartName}
                            onChange={(e) =>
                                onChange(device, { chartName: e.target.value })
                            }
                            placeholder="Widget name"
                        />
                    </Col>
                    <Col xs={12} md={1} className="py-2 text-truncate">
                        <span title={displaySensorType(device)}>
                            {displaySensorType(device)}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        {device.gatewayName}
                    </Col>
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        <span title={device.ldsuUID}>{device.ldsuUID}</span>
                    </Col>
                    <Col xs={12} md={1} className="py-2 ">
                        <UnitPicker
                            data={device.unitOptions || [device.unit]}
                            defaultValue={device.unit}
                            onChange={(_event: any, unit: string) =>
                                onChange(device, { unit: unit })
                            }
                        />
                    </Col>
                    <Col xs={12} md={1} className="py-2">
                        <ColorPicker
                            defaultValue={device.color as string}
                            onChange={(_event: any, color: string) =>
                                onChange(device, { color: color })
                            }
                        />
                    </Col>
                    <Col
                        xs={12}
                        md={2}
                        className="py-2 d-flex justify-content-between"
                    >
                        <Form.Check
                            type="switch"
                            checked={device.alert}
                            name="alert"
                            onChange={(e) =>
                                onChange(device, { alert: e.target.checked })
                            }
                            // style={{ margin: '0 auto' }}
                            id={`${device.deviceId}_alert`}
                            disabled={!device.alertAvailable}
                            defaultChecked={device.alert}
                        />

                        <CloseOutlined
                            onClick={() => onRemove(device)}
                            aria-label="Remove"
                            className="cursor-pointer mr-2 text-primary-red-1"
                        />
                    </Col>
                </Row>
            ))}
        </div>
    );
};

const CardDeviceList = ({
    devices,
    onChange,
    onRemove,
}: SelectedDeviceList) => {
    return (
        <div className="cstm-table w-100 px-2">
            {/* Header Row */}
            <Row className="d-none d-md-flex table-head px-2">
                <Col md={2}>Sensor</Col>
                <Col md={2}>Widget Name</Col>
                <Col md={2}>Type</Col>
                <Col md={2}>{GATEWAY_LABEL}</Col>
                <Col md={3}>{LDSU_UUID_LABEL}</Col>
            </Row>
            {/* Data Rows */}
            {devices.map((device, idx) => (
                <Row
                    key={device.ldsuUID + idx}
                    className="px-2 mb-2  align-items-center bg-secondary mb-2"
                >
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        <span title={device.sensorName}>
                            {device.sensorName}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2">
                        <Form.Control
                            type="text"
                            defaultValue={device.chartName}
                            onChange={(e) =>
                                onChange(device, { chartName: e.target.value })
                            }
                            placeholder="Widget Name"
                        />
                    </Col>
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        <span title={displaySensorType(device)}>
                            {displaySensorType(device)}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        <span title={device.gatewayName}>
                            {device.gatewayName}
                        </span>
                    </Col>
                    <Col xs={12} md={3} className="py-2 text-truncate">
                        <span title={device.ldsuUID}>{device.ldsuUID}</span>
                    </Col>
                    <Col className="py-2 d-flex justify-content-end align-items-center">
                        <CloseOutlined
                            onClick={() => onRemove(device)}
                            aria-label="Remove"
                            className="cursor-pointer mr-2 text-primary-red-1"
                        />
                    </Col>
                </Row>
            ))}
        </div>
    );
};

const DialDeviceList = ({
    devices,
    onChange,
    onRemove,
}: SelectedDeviceList) => {
    return (
        <div className="cstm-table w-100 px-2">
            {/* Header Row */}
            <Row className="d-none d-md-flex table-head px-2">
                <Col md={1}>Sensor</Col>
                <Col md={2}>Dial Name</Col>
                <Col md={1}>Type</Col>
                <Col md={2}>{GATEWAY_LABEL}</Col>
                <Col md={3}>{LDSU_UUID_LABEL}</Col>
                <Col md={1}>Unit</Col>
                <Col md={1}>Color</Col>
                <Col></Col>
            </Row>
            {/* Data Rows */}
            {devices.map((device, idx) => (
                <Row
                    key={device.ldsuUID + idx}
                    className="bg-secondary px-2 mb-2 align-items-center"
                >
                    <Col xs={12} md={1} className="py-2 text-truncate">
                        <span title={device.sensorName}>
                            {device.sensorName}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2 ">
                        <Form.Control
                            type="text"
                            defaultValue={device.chartName}
                            onChange={(e) =>
                                onChange(device, { chartName: e.target.value })
                            }
                            placeholder="Dial Name"
                        />
                    </Col>
                    <Col xs={12} md={1} className="py-2 text-truncate">
                        <span title={displaySensorType(device)}>
                            {displaySensorType(device)}
                        </span>
                    </Col>
                    <Col xs={12} md={2} className="py-2 text-truncate">
                        <span title={device.gatewayName}>
                            {device.gatewayName}
                        </span>
                    </Col>
                    <Col xs={12} md={3} className="py-2 text-truncate">
                        <span title={device.ldsuUID}>{device.ldsuUID}</span>
                    </Col>
                    <Col xs={12} md={1} className="py-2">
                        <UnitPicker
                            data={device.unitOptions || [device.unit]}
                            defaultValue={device.unit}
                            onChange={(_event: any, unit: string) =>
                                onChange(device, { unit: unit })
                            }
                        />
                    </Col>
                    <Col xs={12} md={1} className="py-2 ">
                        <ColorPicker
                            defaultValue={device.color as string}
                            onChange={(_event: any, color: string) =>
                                onChange(device, { color: color })
                            }
                        />
                    </Col>
                    <Col className="py-2 d-flex justify-content-end align-items-center">
                        <CloseOutlined
                            onClick={() => onRemove(device)}
                            aria-label="Remove"
                            className="cursor-pointer mr-2 text-primary-red-1"
                        />
                    </Col>
                </Row>
            ))}
        </div>
    );
};

const WidgetTypeListMap = {
    [WidgetTypeList.Card]: CardDeviceList,
    [WidgetTypeList.Chart]: ChartDeviceList,
    [WidgetTypeList.Dial]: DialDeviceList,
};

/**
 * Renders a list component based on the specified device type.
 * It dynamically selects the appropriate component from the WidgetTypeListMap
 * and passes the devices, onChange, and onRemove props to it.
 *
 * @param {SingleSelectedDeviceListProps} devices - The list of devices to display.
 * @param {string} type - The type of widget to render (e.g., Chart or Card).
 * @param {function} onChange - Callback function to handle changes in the device list.
 * @param {function} onRemove - Callback function to handle removal of a device.
 * @returns {JSX.Element} The rendered list component.
 * @throws {Error} Throws an error if the type does not match any known widget type.
 */
const SingleSelectedDeviceList = ({
    devices,
    type,
    onChange,
    onRemove,
}: SingleSelectedDeviceListProps) => {
    let type_ = WidgetTypeList.Chart;

    if (type === WidgetTypeList.Card) {
        type_ = WidgetTypeList.Card;
    } else if (type === WidgetTypeList.Dial) {
        type_ = WidgetTypeList.Dial;
    }

    const ListComponent = WidgetTypeListMap[type_];

    return (
        <ListComponent
            devices={devices}
            onChange={onChange}
            onRemove={onRemove}
        />
    );
};

export default SingleSelectedDeviceList;
